// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '../../../../../../../node_module_clones/recompose';

// Selectors
import { boardEditorAddSectionSelector } from './boardEditorSuggestionsSelector';

// Actions
import { addUserAsEditor, submitAddEditorInputText } from './boardEditorPanelActions';
import { navigateToEmailVerification } from '../../../../../../reducers/navigationActions';
import { openSheet } from '../../../../../../mobile/structural/sheet/sheetActions';

// Components
import fetchGoogleContactsOnMountDecorator from '../../../../../../user/google/components/fetchGoogleContactsOnMountDecorator';
import UserSelectionInput from '../../../../../../components/form/fields/userSelectionInput/UserSelectionInput';
import LoadableEmailVerificationRequiredModal from '../../../../../../user/account/emailVerification/LoadableEmailVerificationRequiredModal';

// Constants
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';

// Styles
import './BoardEditorAddSection.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchAddUserAsEditor: ({ user }) => dispatch(addUserAsEditor({ user })),
    dispatchAddEditorInputText: ({ inputText }) => dispatch(submitAddEditorInputText({ inputText })),
    dispatchOpenEmailVerificationModal: () => dispatch(navigateToEmailVerification()),
    dispatchOpenEmailVerificationSheet: () => dispatch(openSheet(SheetId.EmailVerificationRequired)),
});

const enhance = compose(
    fetchGoogleContactsOnMountDecorator,
    connect(boardEditorAddSectionSelector, mapDispatchToProps),
);

const BoardEditorAddSection = (props) => {
    const {
        dispatchAddUserAsEditor,
        dispatchAddEditorInputText,
        dispatchOpenEmailVerificationModal,
        filterUserIds,
        isCurrentUserEmailVerified,
        isPhoneOrMobileAppMode,
        dispatchOpenEmailVerificationSheet,
        onValidateBeforeAdd,
        onClearError,
    } = props;

    const inputRef = React.useRef();

    React.useEffect(() => {
        !isPhoneOrMobileAppMode && !isCurrentUserEmailVerified && LoadableEmailVerificationRequiredModal.preload();
    }, []);

    const onFocusUnverifiedUser = () => {
        if (isPhoneOrMobileAppMode) {
            dispatchOpenEmailVerificationSheet();
        } else {
            dispatchOpenEmailVerificationModal();
        }

        inputRef.current && inputRef.current.blur();
    };

    const onInputFocus = () => {
        // Clear any existing error when user clicks on the input
        onClearError?.();

        // Handle unverified user case
        if (!isCurrentUserEmailVerified) {
            onFocusUnverifiedUser();
        }
    };

    const onInputBlur = () => {
        // Clear any existing error when user clicks outside the input
        onClearError?.();
    };

    const clearInputFocusForMobileAppMode = () => {
        if (isPhoneOrMobileAppMode && inputRef.current) {
            inputRef.current.blur();
        }
    };

    const handleSubmitSelectUser = (user) => {
        // Clear any previous error
        onClearError?.();

        // Validate before proceeding
        if (onValidateBeforeAdd && !onValidateBeforeAdd()) {
            return; // Validation failed, error is already set
        }

        dispatchAddUserAsEditor(user);
        clearInputFocusForMobileAppMode();
    };

    const handleSubmitSelectUserViaText = (inputText) => {
        // Clear any previous error
        onClearError?.();

        // Validate before proceeding
        if (onValidateBeforeAdd && !onValidateBeforeAdd()) {
            return; // Validation failed, error is already set
        }

        dispatchAddEditorInputText(inputText);
        clearInputFocusForMobileAppMode();
    };

    return (
        <div className="BoardEditorAddSection">
            <UserSelectionInput
                submitLabel="Send invite"
                inputRef={inputRef}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                filterUserIds={filterUserIds}
                handleSubmitSelectUser={handleSubmitSelectUser}
                handleSubmitSelectUserViaText={handleSubmitSelectUserViaText}
                isPhoneOrMobileAppMode={isPhoneOrMobileAppMode}
            />
        </div>
    );
};

BoardEditorAddSection.propTypes = {
    dispatchAddUserAsEditor: PropTypes.func,
    dispatchOpenEmailVerificationModal: PropTypes.func,
    dispatchAddEditorInputText: PropTypes.func,
    dispatchOpenEmailVerificationSheet: PropTypes.func,
    filterUserIds: PropTypes.array,
    isCurrentUserEmailVerified: PropTypes.bool,
    currentUserEmail: PropTypes.string,
    isPhoneOrMobileAppMode: PropTypes.bool,
    onValidateBeforeAdd: PropTypes.func,
    onClearError: PropTypes.func,
};

export default enhance(BoardEditorAddSection);
